var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrderAscending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.742 6.25-.195.975s-.207.72-.703 1.446C9.348 9.4 8.725 10 7.5 10v2.5c1.72 0 2.9-.844 3.75-1.758v8.008h2.5V6.25zm-.117 15a4.39 4.39 0 0 0-4.375 4.375v.625h2.5v-.625c0-1.095.78-1.875 1.875-1.875h1.25c1.095 0 1.875.78 1.875 1.875 0 .57-.441 1.225-1.172 1.68-1.543.95-2.896 1.555-4.023 2.188-.565.316-1.084.62-1.525 1.093-.438.472-.78 1.188-.78 1.913v1.25h10v-2.5h-5.704c.92-.473 1.975-.945 3.36-1.798 1.269-.791 2.344-2.145 2.344-3.826a4.39 4.39 0 0 0-4.375-4.375zM35.15 14c-.212.48-.692.8-1.118.8h-3.835v17.238c0 .96-.8 1.705-1.705 1.705a1.683 1.683 0 0 1-1.704-1.705V14.8h-3.889c-.532 0-1.012-.32-1.172-.799a1.308 1.308 0 0 1 .213-1.385l5.54-5.966c.533-.532 1.385-.532 1.865 0l5.54 5.966c.425.373.479.906.266 1.385Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrderAscending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/order-ascending.983d4f4533df552ae7c806f2597d6620.svg";